<template>
  <el-card class="card-main">
    <el-form ref="searchForm" :model="searchForm" class="global-form" :inline="true">
      <el-form-item>
        <el-select v-model="searchForm.assessmentType" placeholder="请选择考核大项" filterable clearable>
          <el-option v-for="item in assessmentTypeList" :key="item.dicCode" :label="item.dicValue"
            :value="item.dicCode"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.scoreNo" size='small' placeholder="请输入考核细则编号" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-input v-model="searchForm.score" size='small' placeholder="请输入扣分值" clearable></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="onSearch" class="medium">查询</el-button>
      </el-form-item>
    </el-form>
    <el-button class="mb20" size='small' @click="addRule" v-if="$ButtonShow('ASE_ADD_01')" type="primary" icon='el-icon-plus'>新增考核细则</el-button>
    <el-table class="global-table" stripe :data="tableData" v-loading="loading">
      <el-table-column label="考核细则编号" prop="scoreNo"></el-table-column>
      <el-table-column label="考核大项" prop="assessmentTypeName"></el-table-column>
      <el-table-column label="考核内容及作业服务内容标准" prop="assessmentContent"></el-table-column>
      <el-table-column label="扣分标准" prop="scoreStandard"></el-table-column>
      <el-table-column label="扣分值" prop="score"></el-table-column>
      <el-table-column label="操作" width="100px" fixed="right">
        <template v-slot="{ row }">
          <el-button type="text" v-if="$ButtonShow('ASE_EDT_01')" @click="$router.push(`/assessmentrules/edit?scoreId=${row.scoreId}`)">编辑</el-button>
          <el-button type="text" v-if="$ButtonShow('ASE_DEL_01')" @click="onDelete(row.scoreId)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <GlobalPagination :total="total" :current-page.sync="page" :page-size.sync="size" @current-change="loadData"
      @size-change="loadData"></GlobalPagination>
  </el-card>
</template>
<script>
export default {
  name: 'AssessmentRules',
  components: {
  },
  data() {
    return {
      searchForm: {
        scoreNo: '', // 扣分编号
        assessmentType: '', // 考核项分类(字典assessmentType)
        score: '' // 扣分值
      },
      assessmentTypeList: [],
      tableData: [],
      total: 0,
      page: 1,
      size: 10,
      loading: false
    }
  },
  computed: {
  },
  created() {
    this.loadDict()
    this.loadData()
  },
  methods: {
    // 搜索
    onSearch() {
      this.page = 1
      this.loadData()
    },
    loadDict() {
      this.$axios.get(this.$apis.common.selectDicByList, { dicType: 'assessmentType' }).then(res => {
        this.assessmentTypeList = res.assessmentType || []
      })
    },
    // 获取列表数据
    loadData() {
      this.loading = true
      this.$axios.get(this.$apis.assessmentScore.selectAssessmentScoreByPage, {
        page: this.page,
        size: this.size,
        ...this.searchForm
      }).then(res => {
        this.total = res.total || 0
        this.tableData = res.list || []
      }).finally(() => {
        this.loading = false
      })
    },
    addRule() {
      this.$router.push('/assessmentrules/add')
    },
    onDelete(scoreId) {
      this.$confirm('确认删除吗, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.$axios.post(this.$apis.assessmentScore.deleteAssessmentScore, {
          scoreId
        }).then(() => {
          this.$message({ message: '删除成功', type: 'success' })
          this.loadData()
        })
      })
    },
  }
}
</script>

<style scoped lang="scss"></style>
